import PropTypes from "prop-types";

import clsx from "clsx";

import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";

import useStyles from "./modal.styles";

export const Modal = ({
  open,
  onClose,
  title,
  children,
  onConfirm,
  cancelButtonText,
  confirmButtonText,
  actionsDisabled,
  actionConfirmDisabled,
  isRequestPerforming,
  hideButtonConfirm,
  isBigModal,
  customHeader,
  customCss,
  customCssCancelBtn,
  customCssConfirmBtn,
  variantCancelBtn,
  variantConfirmBtn,
  colorCancelBtn,
  customCssDialogActions,
  maxWidth,
  iconConfirmBtn,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      data-testid="dialog"
      maxWidth={maxWidth}
      fullWidth
      open={open}
      onClose={onClose}
      className={[
        clsx({
          [classes.dialog]: true,
          [classes.bigModal]: isBigModal,
        }),
        customCss,
      ].join(" ")}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {isRequestPerforming && (
        <div className={classes.root}>
          <LinearProgress color="secondary" />
        </div>
      )}
      {customHeader || (
        <Grid container style={{ justifyContent: "space-between" }}>
          <DialogTitle
            className={classes.dialogTitle}
            data-testid="alert-dialog-title"
            id="alert-dialog-title"
            title={title}
          >
            {title}
          </DialogTitle>
          <IconButton
            data-testid="dialog-icon-btn-close"
            name="errors"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      )}

      <DialogContent>{children}</DialogContent>
      <DialogActions className={customCssDialogActions}>
        <Button
          disabled={actionsDisabled}
          onClick={onClose}
          data-testid="dialog-btn-cancel"
          className={[classes.btn, customCssCancelBtn].join(" ")}
          variant={variantCancelBtn}
          color={colorCancelBtn}
        >
          {cancelButtonText}
        </Button>
        {!hideButtonConfirm ? (
          <Button
            onClick={onConfirm}
            disabled={actionsDisabled || actionConfirmDisabled}
            variant={variantConfirmBtn}
            className={[classes.btn, customCssConfirmBtn].join(" ")}
            color="primary"
            data-testid="dialog-btn-delete"
            endIcon={iconConfirmBtn}
            autoFocus
          >
            {confirmButtonText}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  customHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  actionsDisabled: PropTypes.bool,
  actionConfirmDisabled: PropTypes.bool,
  isRequestPerforming: PropTypes.bool,
  hideButtonConfirm: PropTypes.bool,
  isBigModal: PropTypes.bool,
  customCss: PropTypes.string,
  customCssCancelBtn: PropTypes.string,
  customCssConfirmBtn: PropTypes.string,
  customCssDialogActions: PropTypes.string,
  variantCancelBtn: PropTypes.string,
  variantConfirmBtn: PropTypes.string,
  colorCancelBtn: PropTypes.string,
  maxWidth: PropTypes.string,
  iconConfirmBtn: PropTypes.node,
};

Modal.defaultProps = {
  cancelButtonText: "Cancel",
  confirmButtonText: "Delete",
  actionsDisabled: false,
  actionConfirmDisabled: false,
  isRequestPerforming: false,
  hideButtonConfirm: false,
  isBigModal: false,
  customHeader: null,
  customCss: "",
  customCssCancelBtn: "",
  customCssConfirmBtn: "",
  customCssDialogActions: "",
  variantCancelBtn: "outlined",
  variantConfirmBtn: "contained",
  colorCancelBtn: "secondary",
  maxWidth: "sm",
  iconConfirmBtn: null,
};
